import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=0d2bbcb0&scoped=true&"
import script from "./pool.vue?vue&type=script&lang=js&"
export * from "./pool.vue?vue&type=script&lang=js&"
import style0 from "./pool.vue?vue&type=style&index=0&id=0d2bbcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bbcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2bbcb0')) {
      api.createRecord('0d2bbcb0', component.options)
    } else {
      api.reload('0d2bbcb0', component.options)
    }
    module.hot.accept("./pool.vue?vue&type=template&id=0d2bbcb0&scoped=true&", function () {
      api.rerender('0d2bbcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/dividend/pool.vue"
export default component.exports